"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinalClaimPartitionKey = void 0;
exports.getFinalClaimPartitionKey = function (finalClaim) {
    if (finalClaim.cmhcLoanAccountNumber == null) {
        throw new Error("finalClaim's cmhcLoanAccountNumber is null");
    }
    return finalClaim.cmhcLoanAccountNumber.toString();
};
